export default "__VITE_ASSET__fm3gMggG__"